// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Footer_footer__-es43 {
  background-color: var(--color-primary-4);
  color: var(--color-white);
  max-width: 100vw;
  padding: 10rem 0rem;
}
.Footer_footer_a__tjx-H {
  display: flex;
  justify-content: space-around;
}
@media only screen and (max-width: 62.5em) {
  .Footer_footer_a__tjx-H {
    flex-direction: column;
    align-items: center;
  }
  .Footer_footer__go__e2XW5 {
    margin-bottom: 3rem;
  }
}
.Footer_footer__pcl__b2fNU {
  display: flex;
  justify-content: space-around;
  margin-bottom: 3rem;
}
@media only screen and (max-width: 37.5em) {
  .Footer_footer__pcl__b2fNU {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
.Footer_footer__statement__\\+ATtQ {
  margin-bottom: 3rem;
  padding-left: 3rem;
  width: 75rem;
}
@media only screen and (max-width: 62.5em) {
  .Footer_footer__statement__\\+ATtQ {
    text-align: center;
  }
}
@media only screen and (max-width: 37.5em) {
  .Footer_footer__statement__\\+ATtQ {
    width: 60rem;
  }
}
@media only screen and (max-width: 31.25em) {
  .Footer_footer__statement__\\+ATtQ {
    width: 32rem;
    text-align: center;
    padding: 0;
  }
}
.Footer_footer__copyright__nHK9x {
  display: flex;
  justify-content: center;
  font-size: var(--default-font-size);
  font-weight: 700;
  margin-top: 5rem;
}
@media only screen and (max-width: 31.25em) {
  .Footer_footer__copyright__nHK9x {
    text-align: center;
  }
}
.Footer_footer__contact__VpCJs {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
@media only screen and (max-width: 62.5em) {
  .Footer_footer__contact__VpCJs {
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    width: 100%;
  }
}
@media only screen and (max-width: 31.25em) {
  .Footer_footer__contact__VpCJs {
    flex-direction: column;
  }
}
.Footer_footer__socials__Q4PsB {
  display: flex;
  justify-content: flex-end;
}
@media only screen and (max-width: 62.5em) {
  .Footer_footer__socials__Q4PsB {
    justify-content: flex-start;
  }
}
@media only screen and (max-width: 31.25em) {
  .Footer_footer__socials__Q4PsB {
    justify-content: center;
  }
}
.Footer_footer__socials__Q4PsB {
  margin-top: 1.5rem;
  margin-bottom: 1rem;
}
.Footer_footer__socials__Q4PsB > * {
  font-size: 2.5rem;
}
.Footer_footer__socials__Q4PsB > *:not(:last-child) {
  margin-right: 1rem;
}

.Footer_contact__FiU3T {
  text-align: end;
  line-height: 3rem;
}
@media only screen and (max-width: 31.25em) {
  .Footer_contact__FiU3T {
    text-align: center;
    margin-top: 2rem;
  }
}

@media only screen and (max-width: 37.5em) {
  .Footer_pcl__m9QK0 {
    text-align: center;
    margin-bottom: 3rem;
  }
}
.Footer_pcl__header__ajNd3 {
  font-weight: 700;
  margin-bottom: 2rem;
}
.Footer_pcl__list__2Npmc {
  list-style: none;
  margin-bottom: 2rem;
}
.Footer_pcl__item__ji5rk {
  text-decoration: none;
  color: var(--color-white);
}
.Footer_pcl__item__ji5rk:hover {
  color: var(--color-primary-3);
}
.Footer_pcl__ul__NME6o {
  list-style: none;
  margin: 0;
  padding: 0;
}

.Footer_logo__main__zMIv\\+ {
  height: 4rem;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/LandingPage/Footer.module.scss"],"names":[],"mappings":"AAEA;EACC,wCAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;AADD;AAGC;EACC,aAAA;EACA,6BAAA;AADF;AAEE;EAHD;IAIE,sBAAA;IACA,mBAAA;EACD;EAGD;IAEE,mBAAA;EAAD;AAJF;AAQC;EACC,aAAA;EACA,6BAAA;EACA,mBAAA;AADF;AAGE;EALD;IAME,aAAA;IACA,sBAAA;IACA,mBAAA;EAAD;AACF;AAGC;EACC,mBAAA;EACA,kBAAA;EACA,YAAA;AADF;AAEE;EAJD;IAKE,kBAAA;EACD;AACF;AAAE;EAPD;IAQE,YAAA;EAGD;AACF;AAFE;EAVD;IAWE,YAAA;IACA,kBAAA;IACA,UAAA;EAKD;AACF;AAFC;EACC,aAAA;EACA,uBAAA;EACA,mCAAA;EACA,gBAAA;EACA,gBAAA;AAIF;AAHE;EAND;IAOE,kBAAA;EAMD;AACF;AAHC;EACC,aAAA;EACA,sBAAA;EACA,qBAAA;AAKF;AAHE;EALD;IAME,mBAAA;IACA,mBAAA;IACA,6BAAA;IACA,WAAA;EAMD;AACF;AAJE;EAZD;IAaE,sBAAA;EAOD;AACF;AAJC;EACC,aAAA;EACA,yBAAA;AAMF;AAJE;EAJD;IAKE,2BAAA;EAOD;AACF;AALE;EARD;IASE,uBAAA;EAQD;AACF;AAlBC;EAYC,kBAAA;EACA,mBAAA;AASF;AARE;EACC,iBAAA;AAUH;AAPE;EACC,kBAAA;AASH;;AAJA;EACC,eAAA;EACA,iBAAA;AAOD;AALC;EAJD;IAKE,kBAAA;IACA,gBAAA;EAQA;AACF;;AAJC;EADD;IAEE,kBAAA;IACA,mBAAA;EAQA;AACF;AAPC;EACC,gBAAA;EACA,mBAAA;AASF;AANC;EACC,gBAAA;EACA,mBAAA;AAQF;AALC;EACC,qBAAA;EACA,yBAAA;AAOF;AALE;EACC,6BAAA;AAOH;AAHC;EACC,gBAAA;EACA,SAAA;EACA,UAAA;AAKF;;AAAC;EACC,YAAA;AAGF","sourcesContent":["@import '../variables/breakpoints';\n\n.footer {\n\tbackground-color: var(--color-primary-4);\n\tcolor: var(--color-white);\n\tmax-width: 100vw;\n\tpadding: 10rem 0rem;\n\n\t&_a {\n\t\tdisplay: flex;\n\t\tjustify-content: space-around;\n\t\t@media only screen and (max-width: $bp-large) {\n\t\t\tflex-direction: column;\n\t\t\talign-items: center;\n\t\t}\n\t}\n\n\t&__go {\n\t\t@media only screen and (max-width: $bp-large) {\n\t\t\tmargin-bottom: 3rem;\n\t\t}\n\t}\n\n\t&__pcl {\n\t\tdisplay: flex;\n\t\tjustify-content: space-around;\n\t\tmargin-bottom: 3rem;\n\n\t\t@media only screen and (max-width: $bp-small) {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\talign-items: center;\n\t\t}\n\t}\n\n\t&__statement {\n\t\tmargin-bottom: 3rem;\n\t\tpadding-left: 3rem;\n\t\twidth: 75rem;\n\t\t@media only screen and (max-width: $bp-large) {\n\t\t\ttext-align: center;\n\t\t}\n\t\t@media only screen and (max-width: $bp-small) {\n\t\t\twidth: 60rem;\n\t\t}\n\t\t@media only screen and (max-width: 31.25em) {\n\t\t\twidth: 32rem;\n\t\t\ttext-align: center;\n\t\t\tpadding: 0;\n\t\t}\n\t}\n\n\t&__copyright {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\tfont-size: var(--default-font-size);\n\t\tfont-weight: 700;\n\t\tmargin-top: 5rem;\n\t\t@media only screen and (max-width: 31.25em) {\t\t\t\t\n\t\t\ttext-align: center;\t\t\n\t\t}\n\t}\n\n\t&__contact {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: flex-end;\n\n\t\t@media only screen and (max-width: $bp-large) {\n\t\t\tflex-direction: row;\n\t\t\talign-items: center;\n\t\t\tjustify-content: space-around;\n\t\t\twidth: 100%;\n\t\t}\n\n\t\t@media only screen and (max-width: 31.25em) {\n\t\t\tflex-direction: column;\n\t\t}\n\t}\n\n\t&__socials {\n\t\tdisplay: flex;\n\t\tjustify-content: flex-end;\n\n\t\t@media only screen and (max-width: $bp-large) {\n\t\t\tjustify-content: flex-start;\n\t\t}\n\n\t\t@media only screen and (max-width: 31.25em) {\n\t\t\tjustify-content: center;\n\t\t}\n\n\t\tmargin-top: 1.5rem;\n\t\tmargin-bottom: 1rem;\n\t\t& > * {\n\t\t\tfont-size: 2.5rem;\n\t\t}\n\n\t\t& > *:not(:last-child) {\n\t\t\tmargin-right: 1rem;\n\t\t}\n\t}\n}\n\n.contact {\n\ttext-align: end;\n\tline-height: 3rem;\n\n\t@media only screen and (max-width: 31.25em) {\n\t\ttext-align: center;\n\t\tmargin-top: 2rem;\n\t}\n}\n\n.pcl {\n\t@media only screen and (max-width: $bp-small) {\n\t\ttext-align: center;\n\t\tmargin-bottom: 3rem;\n\t}\n\t&__header {\n\t\tfont-weight: 700;\n\t\tmargin-bottom: 2rem;\n\t}\n\n\t&__list {\n\t\tlist-style: none;\n\t\tmargin-bottom: 2rem;\n\t}\n\n\t&__item {\n\t\ttext-decoration: none;\n\t\tcolor: var(--color-white);\n\n\t\t&:hover {\n\t\t\tcolor: var(--color-primary-3);\n\t\t}\n\t}\n\n\t&__ul {\n\t\tlist-style: none;\n\t\tmargin: 0;\n\t\tpadding: 0;\n\t}\n}\n\n.logo {\n\t&__main {\n\t\theight: 4rem;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `Footer_footer__-es43`,
	"footer_a": `Footer_footer_a__tjx-H`,
	"footer__go": `Footer_footer__go__e2XW5`,
	"footer__pcl": `Footer_footer__pcl__b2fNU`,
	"footer__statement": `Footer_footer__statement__+ATtQ`,
	"footer__copyright": `Footer_footer__copyright__nHK9x`,
	"footer__contact": `Footer_footer__contact__VpCJs`,
	"footer__socials": `Footer_footer__socials__Q4PsB`,
	"contact": `Footer_contact__FiU3T`,
	"pcl": `Footer_pcl__m9QK0`,
	"pcl__header": `Footer_pcl__header__ajNd3`,
	"pcl__list": `Footer_pcl__list__2Npmc`,
	"pcl__item": `Footer_pcl__item__ji5rk`,
	"pcl__ul": `Footer_pcl__ul__NME6o`,
	"logo__main": `Footer_logo__main__zMIv+`
};
export default ___CSS_LOADER_EXPORT___;
